<template>
  <div
    class="ce-onlyNewFilter"
    :class="{ 'disabled': disabled }">
    <checkbox
      :disabled="!!disabled"
      :id="`key-${filterKey}`"
      :model-value="active"
      @update:model-value="toggle">
      {{ label }}
    </checkbox>

    <div
      v-if="hasLegend"
      class="ce-onlyNewFilter-legend">
      <div
        v-for="(row, index) in legend"
        :key="index">
        <div
          class="ce-onlyNewFilter-legend-indicator"
          :class="[`ce-onlyNewFilter-legend-indicator--${row.indicator}`]" />
        {{ row.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatISO } from 'date-fns';

import Checkbox from 'components/Checkbox.vue';

export default {
  props: {
    filterKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    minDate: {
      type: String,
      required: false,
      default: () => formatISO(new Date()),
    },
    disabled: {
      type: Boolean || null,
      default: false
    },
    legend: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  components: { Checkbox },
  computed: {
    ...mapGetters(['urlFilters']),
    active() {
      return this.urlFilters && this.urlFilters.hasOwnProperty(this.filterKey);
    },
    hasLegend() {
      return this.legend && Array.isArray(this.legend) && this.legend.length > 0;
    }
  },
  methods: {
    toggle(value) {
      const url = this.$cloneObject(this.urlFilters);
      this.$trackEvent('filter', 'toggle', {
        filterType: 'only_new',
        filterKey: this.filterKey,
        filterLabel: this.label,
        value
      });

      if (!value) {
        delete url[this.filterKey];
      } else {
        url[this.filterKey] = this.minDate;
      }

      this.$store.dispatch('setUrlFilters', url);
    }
  }
};
</script>

<style lang="less">
@import (reference) "~styles/includes/base";

.ce-onlyNewFilter {
  margin-bottom: @space-3;
  padding: @space-2 @space-3;
  background: @ce-filter-background-color;
  border-radius: @border-radius;
  border: 1px solid @ce-filter-border-color;
  color: @ce-filter-color;
  .noselect();

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .ce-onlyNewFilter-legend {
    margin-top: @space-3;
    padding: 0 5px;

    > div {
      display: flex;
      align-items: center;

      &:not(:last-child) {
        margin-bottom: @space-1;
      }

      .ce-onlyNewFilter-legend-indicator {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: @space-2;

        &--green {
          background: @color-secondary;
        }

        &--red {
          background: @color-light;
        }
      }
    }
  }
}
</style>
